const oneByoneMarketplaceToAmazonMarketplaceMapping = {
  US: "amazon.com",
  UK: "amazon.co.uk",
  DE: "amazon.de",
  IT: "amazon.it",
  ES: "amazon.es",
  FR: "amazon.fr",
  AU: "amazon.au",
  CA: "amazon.ca",
  AE: "amazon.ae",
  SG: "amazon.sg"
};

const amazonMarketplaceDomainSuffixMapping = {
  US: ".com",
  UK: ".co.uk",
  DE: ".de",
  IT: ".it",
  ES: ".es",
  FR: ".fr",
  AU: ".au",
  CA: ".ca",
  AE: ".ae",
  SG: ".sg"
};

export const getAmazonMarketplace = onebyoneMarketplace => {
  let amazonMarketplace =
    oneByoneMarketplaceToAmazonMarketplaceMapping[onebyoneMarketplace];
  return amazonMarketplace;
};

export const getAmazonMarketplaceDomainSuffix = countryCode => {
  return amazonMarketplaceDomainSuffixMapping[countryCode];
};
